import { Injectable } from '@angular/core';

import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';

import { CommonService } from './common.service';
import { ShareService } from './share.service';

import { QuestionType } from '../app.constant';

import { environment } from '../../environments/environment';

@Injectable()
export class MonshinService {

  constructor(private http: HttpClient, private commonService: CommonService, private shareService: ShareService) { }

  private questionList: any;

  private Q_TYPE: any = QuestionType;
  private httpOptions = this.commonService.httpOptions;
  private Options  = this.commonService.Options;

  public getHomeInfoList() {
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+`/api/monshin/homeInfoList`, this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError<any[]>('getHomeInfoList', []))
      );
  }

  public getQuestionList(params) {

    //GETで取得するパラメータをセット
    let option = this.httpOptions;
    option["params"] = params;

    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+`/api/monshin/questionList`, option)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError<any[]>('getQuestionList', []))
      );
  }

  public getStartQuestionList(params) {
    let option = this.httpOptions;
    option["params"] = params;

    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+`/api/monshin/startQuestion`, option)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError<any[]>('getStartQuestionList', []))
      );
  }
  public getInspectionList(params:any) {

    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/monshin/InspectionList/'+ params.chemcal_list + '/'+ params.organic_list)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError<any[]>('getInspectionList', []))
      );
  }
  saveResult(categoryInfo, resultList, status) {
    let param = {
      'category_info': categoryInfo,
      'result_list': resultList,
      'answer_status': status,
    };
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/monshin/saveResult', param, this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveResult', []))
      );
  }

  /**
   * 質問データからDB登録可能なデータ構造を生成
   * ※再帰関数、第n階層・回答がなくなるまで続ける
   * @param rList 
   * @param qList 
   * @param show 質問ループ内のtargetShowが存在すればそちらを参照する(target-questionで基本情報から判定)
   * @param level 何次の質問であるか 
   */
  public createResultData(rList, qList, show, level = 1) {

    let nextLevel = level + 1;
    //第n階層
    for (let i in qList) {
      if (qList[i].targetShow != null) {
        show = qList[i].targetShow;
      }
      //回答結果生成時に親の回答情報(target_answer)を渡す
      let parent_a_id = qList[i]["parent_a_id"];
      let parent_a_str = qList[i]["parent_a_str"];

      let t1 = this.setResult(qList[i], level, show, parent_a_id, parent_a_str);

      //結果がnullであれば次のループへ
      if (t1 == null) continue;

      rList.push(t1);
      let a1 = qList[i]["m_answer_list"];
      //第n階層・回答
      for (let j in a1) {
        let nextQ = (a1[j]["m_answer_nextquestion_group_list"]);
        let nextShow = (qList[i]["t_result_list"]["m_answer_id"] == a1[j]["m_answer_id"] || a1[j]["checked"]) && show;

        //再帰関数
        this.createResultData(rList, nextQ, nextShow, nextLevel);
      }
    }

    return rList;
  }

  /**
   * DB登録可能なデータ構造を生成
   * createResultData内からのみ使用
   * @param obj 1質問 
   * @param level 
   * @param show 
   */
  private setResult(obj, level, show, parent_a_id, parent_a_str) {

    //初期値設定
    let result = {
      "t_id": obj["t_result_list"]["t_result_id"],  //回答結果ID(UPDATE時に使用)
      "q_id": obj["m_question_id"],                 //質問ID
      "q_title": obj["m_question_content_title"],   //質問タイトル
      "q_type": obj["m_question_type_id"],          //質問タイプ(id)
      "a_prefix_label": obj["prefix_label"],        //回答の前ラベル
      "a_suffix_label": obj["suffix_label"],        //回答の後ラベル
      "previous_result_id": obj["t_result_list"]["previous_result_id"],                   //過去質問の回答結果id
      "a_id": null,                                 //単一回答の回答(id)
      "a_str": null,                                //文字列の回答
      "a_id_list": [],                              //複数回答の回答一覧(id)
      "a_sp_id_list": [],                           //特健）複数回答のグループ一覧(id)
      "q_level": level,                             //階層
      "a_val": null,                                //単一回答の回答(name)
      "a_val_list": [],                             //複数回答の回答一覧(name)
      "parent_a_id": null,                          //n次質問の親となる回答(id)
      "parent_a_str": null,                         //n次質問の親となる回答(name)
      "show_flg": show,                             //表示対象であるか
      "a_str_title": null,                          //文字列の回答のタイトル(textbox,textareaでは不使用)
      "previous_flg": 0,                            //過去の質問の回答であるか　0:普通の質問,1:過去質問
      "error_msg":''                                //エラーメッセージ
    };

    //最終回答項目のindex
    let lastIndex = obj["m_answer_list"].length - 1;
    //テキストボックスを追加するか
    let input_flg = obj["m_question_last_text_input_flg"] == 1;
    //最終回答を回答項目に含めるか
    let include_flg = obj["m_question_last_text_input_include_flg"] == 1;

    //基本情報の場合はq_headerを入れる
    if (level == 1 && obj["m_question_content_header"] != null) {
      result["q_header"] = obj["m_question_content_header"];
      result["q_type"] = obj["m_question_type_id"];
    }

    //回答として表示対象か
    if (show) {
      result["a_id"] = obj["t_result_list"]["m_answer_id"];
      result["a_str"] = obj["t_result_list"]["t_result_answer_str"];
      result["a_id_list"] = obj["t_result_list"]["t_result_id_list"];

      //タイトルだったときにレベルを0にする
      if (obj["result_option"] == 2 && obj["m_question_type_id"] == 0) {
        result["q_level"] = 0;
      }

      //過去質問かどうかを保持する
      result["previous_flg"] = obj["previous_flg"];
      //エラー情報を保持する
      result["error_msg"] = obj["error_msg"];

      //2次質問以降の場合値を入れる
      if (level > 1) {
        result["parent_a_id"] = parent_a_id;
        result["parent_a_str"] = parent_a_str;
      }

      //チェック開始
      let error = true;
      for (let i = 0; i < obj["m_answer_list"].length; i++) {
        //単一回答のチェック
        if (result["a_id"] == obj["m_answer_list"][i]["m_answer_id"]) {
          result["a_val"] = obj["m_answer_list"][i]["m_answer_content_name"];
          error = false;
        }
        //複数回答のチェック
        if (obj["m_answer_list"][i]["checked"]) {
          result["a_val_list"].push(obj["m_answer_list"][i]["m_answer_content_name"]);
          result["a_sp_id_list"].push(obj["m_answer_list"][i]["m_ksn_grp_id"]);
          error = false;
        }

        //最終行かつテキストボックス表示の場合
        if (lastIndex == i && input_flg) {
          //最後の選択肢をチェックしている場合で回答項目に含める（チェックにより活性）　
          //  または　回答項目に含めない（常に活性）　　
          if ((include_flg && (obj["m_answer_list"][lastIndex]["m_answer_id"] == result["a_id"] || obj["m_answer_list"][lastIndex]["checked"]))
            || !include_flg) {
              //テキストボックス表示であれば、最後の回答がタイトルになる。
              result["a_str_title"] = obj["m_answer_list"][i]["m_answer_content_name"];
          }else{
            result["a_str"] = null;
          }
        }
      }

      if (obj["m_question_type_id"] == this.Q_TYPE.TEXTBOX || obj["m_question_type_id"] == this.Q_TYPE.TEXTAREA) {
        if (obj["m_question_required_flg"] == 1 && (result["a_str"] == null || result["a_str"].trim().length == 0)) {
          let errorObj = { "error_text": obj["required_msg"], "m_question_id": obj["m_question_id"], "q_title": obj["m_question_content_title"] }
          this.shareService.pushErrorListShare(errorObj);
        }
      }else if (obj["m_question_type_id"] == this.Q_TYPE.DATEYYYYMMFROMTO) {
        if (obj["t_result_list"]["error_msg"]!="") {
          let errorObj = { "error_text": obj["t_result_list"]["error_msg"], "m_question_id": obj["m_question_id"], "q_title": obj["m_question_content_title"] }
          this.shareService.pushErrorListShare(errorObj);
        }else if (obj["m_question_required_flg"] == 1 && (result["a_str"] == null || result["a_str"].trim().length == 0)) {
            let errorObj = { "error_text": obj["required_msg"], "m_question_id": obj["m_question_id"], "q_title": obj["m_question_content_title"] }
            this.shareService.pushErrorListShare(errorObj);
        }
      }else if (obj["m_question_type_id"] == this.Q_TYPE.LABELTEXT1) {
        if (obj["t_result_list"]["error_msg"]!="") {
          let errorObj = { "error_text": obj["t_result_list"]["error_msg"], "m_question_id": obj["m_question_id"], "q_title": obj["m_question_content_title"] }
          this.shareService.pushErrorListShare(errorObj);
        }else if (obj["m_question_required_flg"] == 1 && (result["a_str"] == null || result["a_str"].trim().length == 0)) {
          let errorObj = { "error_text": obj["required_msg"], "m_question_id": obj["m_question_id"], "q_title": obj["m_question_content_title"] }
          this.shareService.pushErrorListShare(errorObj);
        }
      } else {
        if (error && obj["m_question_required_flg"] == "1") {
          //Error出力対象
          //shareにエラー情報を保持させる
          let errorObj = { "error_text": obj["required_msg"], "m_question_id": obj["m_question_id"], "q_title": obj["m_question_content_title"] }
          this.shareService.pushErrorListShare(errorObj);
        }

        //最終コメントの必須チェック
        //最終コメントを含め、最終コメントが必須で文字列回答がnullの時
        if (obj["m_question_last_text_input_required_flg"] == 1
          && input_flg && (result["a_str"] == null || result["a_str"].trim().length == 0)) {

          //最後の選択肢をチェックしている場合で回答項目に含める（チェックにより活性）　
          //  または　回答項目に含めない（常に活性）　
          if ((include_flg && (obj["m_answer_list"][lastIndex]["m_answer_id"] == result["a_id"] || obj["m_answer_list"][lastIndex]["checked"]))
            || !include_flg) {
            let errorObj = {
              "error_text": obj["last_text_input_required_msg"],
              "m_question_id": obj["m_question_id"],
              "q_title": obj["m_question_content_title"]
            };
            this.shareService.pushErrorListShare(errorObj);
          }
        }
      }
    }
    return result;
  }

  //年月の入力チェック
  checkDateFormatFromTo(dates:string){
    if (dates==null || dates==''){
      return true;
    }else{
      var temp1=[];  
      //～でsplit
      temp1 = dates.split('～');
      if (temp1[0]=='' && temp1[1]=='' ){
        return true;
      }else{
        return false;
      }
    }
  }
    //年月が数値かどうかの入力チェック
    checkNumberFormatDate(dates:string){
      var ret =[true,true,true,true];

      if (dates==null || dates==''){
        return true;
      }else{
        var temp1=[];  
        var temp2=[];  
        //～でsplit
        temp1 = dates.split('～');
        if (temp1[0]!=''){
          temp2 = temp1[0].split('/');
          ret[0] = this.checkNumberFormat(temp2[0]);
          ret[1] = this.checkNumberFormat(temp2[1]);
        }
        if (temp1[1]!=''){
          temp2 = temp1[1].split('/');
          ret[2] = this.checkNumberFormat(temp2[0]);
          ret[3] = this.checkNumberFormat(temp2[1]);
        }
      }
      if (ret[0]&&ret[1]&&ret[2]&&ret[3]){
        return true;        
      }else{
        return false;        
      }
    }
    //数字かどうかの入力チェック
    checkNumberFormat(values:any){
      if (values==null || values==''){
        return true;
      }else{
        //値が数値だけか
        var regex = new RegExp(/^[0-9]+$/);
        return regex.test(values);
      }
    }
    
  saveQuestion(categoryInfo, resultList, status) {
    let param = {
      'category_info': categoryInfo,
      'result_list': resultList,
      'answer_status': status,
    };
    if(categoryInfo['t_addition_question_category_id']){
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl + '/api/monshin/save_question', param)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveQuestion', []))
      );
    }else{
      this.commonService.loadingStart();
      return this.http.post(environment.apiUrl + '/api/monshin/saveResult', param)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveQuestion', []))
      );
    }
  }
  // 判定結果を取得
  Hantei(categoryInfo) {
    let param = categoryInfo;

    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+`/api/monshin/hantei`,param,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError<any[]>('Hantei', []))
      );
  }

  public getMendanStartQuestionList(params) {
    let option = this.httpOptions;
    option["params"] = params;

    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+`/api/monshin/mendan_question_list`, option)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError<any[]>('getStartQuestionList', []))
      );
  }

  public getMendanMainQuestionList(params) {
    let option = this.httpOptions;
    option["params"] = params;

    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+`/api/monshin/mendan_main_question_list`, option)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError<any[]>('getStartQuestionList', []))
      );
  }
}


// WEBPACK FOOTER //
// ./src/app/service/monshin.service.ts